import { z } from "zod";

export const productSchema = z.object({
  id: z.string().min(1, "ID is required"),
  row: z.coerce.number().int().nonnegative(),
  category: z.string().min(1, "Category is required"),
  subcategory: z.string().min(1, "Subcategory is required"),
  name: z.string().min(1, "Name is required"),
  link: z.string().url("Must be a valid URL").or(z.literal("")).optional(),
  responsibility: z.string().optional(),

  supports: z.object({
    pemClinch: z.boolean().default(false),
    blindRivet: z.boolean().default(false),
    profile: z.boolean().default(false),
    other: z.boolean().default(false),
  }),

  maxSizeLabel: z.string().optional(),
  maxSize: z.coerce.number().nonnegative().optional(),

  sizes: z.object({
    maxMetricNutSize: z.coerce.number().nonnegative().default(0),
    maxMetricStudSize: z.coerce.number().nonnegative().default(0),
  }),

  maxForceKn: z.coerce.number().nonnegative().optional(),

  features: z.object({
    processMonitoring: z.boolean().default(false),
    robotIntegration: z.boolean().default(false),
  }),

  availability: z.object({
    EU: z.boolean().default(false),
    NA: z.boolean().default(false),
    ASIA: z.boolean().default(false),
  }),

  costModel: z.string().optional(),
  imageLink: z.string().optional(),
  keyCharacteristics: z.array(z.object({ value: z.string() })).default([]),
});

export type ProductFormData = z.infer<typeof productSchema>;
